// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"b4bd219a","151":"a89ca92e","472":"fc55e0d7","474":"3506f572","693":"011569ab","754":"a9aeb347","807":"e3c9e6ba","902":"7f28b802"}[chunkId] + ".chunk.js";
};